/* tu-hacci 共通スクロールフェードイン（top-fb / Figma 260615_top）
   [data-tuha-reveal] 要素がビューポートに入ったら .tuha-reveal--in を付与。 */
(function () {
  if (window.__tuhaRevealInit) return;
  window.__tuhaRevealInit = true;

  function revealAll(root) {
    (root || document).querySelectorAll('[data-tuha-reveal]').forEach(function (el) {
      el.classList.add('tuha-reveal--in');
    });
  }

  if (!('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('tuha-reveal--in');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
  );

  function scan(root) {
    (root || document)
      .querySelectorAll('[data-tuha-reveal]:not(.tuha-reveal--in)')
      .forEach(function (el) {
        io.observe(el);
      });
  }

  scan();

  // Theme editor: re-scan when a section is (re)loaded
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();

// スライドショー: 画像が全て読み込まれてからフェードイン
// （custom_css で opacity:0 を指定したスライドショーのみ対象。未ロードのスライドが先に表示されるのを防ぐ）
(function () {
  function initSlideshowFade(scope) {
    var sections = (scope || document).querySelectorAll('.slideshow-section');
    Array.prototype.forEach.call(sections, function (sec) {
      if (sec.dataset.tuhaFadeInit) return;
      // custom_css で初期 opacity:0 のスライドショーだけを対象にする
      if (getComputedStyle(sec).opacity !== '0') return;
      sec.dataset.tuhaFadeInit = '1';

      var imgs = Array.prototype.slice.call(sec.querySelectorAll('img'));
      var pending = imgs.filter(function (img) { return !img.complete; });
      var done = false;
      function reveal() {
        if (done) return;
        done = true;
        sec.classList.add('tuha-faded');
      }
      if (pending.length === 0) { reveal(); return; }

      var remaining = pending.length;
      function tick() { if (--remaining <= 0) reveal(); }
      pending.forEach(function (img) {
        img.addEventListener('load', tick, { once: true });
        img.addEventListener('error', tick, { once: true });
      });
      // セーフティ: 画像が固まっても最大3秒で必ず表示
      setTimeout(reveal, 3000);
    });
  }

  if (document.readyState !== 'loading') initSlideshowFade();
  else document.addEventListener('DOMContentLoaded', function () { initSlideshowFade(); });
  document.addEventListener('shopify:section:load', function (e) { initSlideshowFade(e.target); });
})();
